!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react"), require("styled-components"), require("@tinacms/icons"), require("@tinacms/react-core")) : "function" == typeof define && define.amd ? define(["exports", "react", "styled-components", "@tinacms/icons", "@tinacms/react-core"], e) : e((n = n || self)["@tinacms/react-alerts"] = {}, n.React, n.styled, n.icons, n.reactCore);
}(this, function (n, t, e, i, a) {
  "use strict";

  t = t && t.hasOwnProperty("default") ? t.default : t;

  var r = "default" in e ? e.default : e,
      _o = function o() {
    return (_o = Object.assign || function (n) {
      for (var e, r = 1, t = arguments.length; r < t; r++) {
        for (var i in e = arguments[r]) {
          Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function l(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  var c,
      s,
      d,
      f,
      p,
      u,
      m,
      g,
      x = r.div.withConfig({
    displayName: "AlertContainer",
    componentId: "sc-1wmy466"
  })(c = c || l(["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 999999;\n"], ["\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 999999;\n"])),
      v = e.keyframes(s = s || l(["\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 100%, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])),
      y = r.div.withConfig({
    displayName: "Alert",
    componentId: "sc-1gq1bxf"
  })(m = m || l(["\n  text-align: center;\n  border: 0;\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-small);\n  background-color: var(--tina-color-grey-1);\n  border: 1px solid var(--tina-color-grey-2);\n  color: var(--tina-color-grey-9);\n  fill: var(--tina-color-primary);\n  font-weight: var(--tina-font-weight-regular);\n  cursor: pointer;\n  font-size: var(--tina-font-size-2);\n  padding: 8px 4px 8px 12px;\n  transition: all var(--tina-timing-short) ease-out;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  min-width: 350px;\n  max-width: 100%;\n\n  animation-name: ", ";\n  animation-timing-function: ease-out;\n  animation-iteration-count: 1;\n  animation-fill-mode: both;\n  animation-duration: 150ms;\n\n  p {\n    margin: 0;\n    flex: 1 0 auto;\n    text-align: left;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    flex: 0 0 auto;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  text-align: center;\n  border: 0;\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-small);\n  background-color: var(--tina-color-grey-1);\n  border: 1px solid var(--tina-color-grey-2);\n  color: var(--tina-color-grey-9);\n  fill: var(--tina-color-primary);\n  font-weight: var(--tina-font-weight-regular);\n  cursor: pointer;\n  font-size: var(--tina-font-size-2);\n  padding: 8px 4px 8px 12px;\n  transition: all var(--tina-timing-short) ease-out;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  min-width: 350px;\n  max-width: 100%;\n\n  animation-name: ", ";\n  animation-timing-function: ease-out;\n  animation-iteration-count: 1;\n  animation-fill-mode: both;\n  animation-duration: 150ms;\n\n  p {\n    margin: 0;\n    flex: 1 0 auto;\n    text-align: left;\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 8px;\n    flex: 0 0 auto;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]), v, function (n) {
    return "info" === n.level && e.css(d = d || l(["\n      fill: var(--tina-color-primary);\n      border-left: 6px solid var(--tina-color-primary);\n    "], ["\n      fill: var(--tina-color-primary);\n      border-left: 6px solid var(--tina-color-primary);\n    "]));
  }, function (n) {
    return "success" === n.level && e.css(f = f || l(["\n      fill: var(--tina-color-success);\n      border-left: 6px solid var(--tina-color-success);\n    "], ["\n      fill: var(--tina-color-success);\n      border-left: 6px solid var(--tina-color-success);\n    "]));
  }, function (n) {
    return "warn" === n.level && e.css(p = p || l(["\n      fill: var(--tina-color-warning-dark);\n      border-left: 6px solid var(--tina-color-warning);\n    "], ["\n      fill: var(--tina-color-warning-dark);\n      border-left: 6px solid var(--tina-color-warning);\n    "]));
  }, function (n) {
    return "error" === n.level && e.css(u = u || l(["\n      fill: var(--tina-color-error);\n      border-left: 6px solid var(--tina-color-error);\n    "], ["\n      fill: var(--tina-color-error);\n      border-left: 6px solid var(--tina-color-error);\n    "]));
  }),
      b = r(function (n) {
    var e = function (n, e) {
      var r = {};

      for (var t in n) {
        Object.prototype.hasOwnProperty.call(n, t) && e.indexOf(t) < 0 && (r[t] = n[t]);
      }

      if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;

        for (t = Object.getOwnPropertySymbols(n); i < t.length; i++) {
          e.indexOf(t[i]) < 0 && Object.prototype.propertyIsEnumerable.call(n, t[i]) && (r[t[i]] = n[t[i]]);
        }
      }

      return r;
    }(n, []);

    return t.createElement("button", _o({}, e), t.createElement(i.CloseIcon, null));
  }).withConfig({
    displayName: "CloseAlert",
    componentId: "sc-1pqgfyv"
  })(g = g || l(["\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin-left: 14px;\n  outline: none;\n  fill: var(--tina-color-grey-5);\n  display: flex;\n  align-items: center;\n\n  svg {\n    width: 20px;\n    height: 20px;\n    flex: 0 0 auto;\n  }\n"], ["\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin-left: 14px;\n  outline: none;\n  fill: var(--tina-color-grey-5);\n  display: flex;\n  align-items: center;\n\n  svg {\n    width: 20px;\n    height: 20px;\n    flex: 0 0 auto;\n  }\n"]));
  n.Alerts = function (n) {
    var r = n.alerts;
    return a.useSubscribable(r), r.all.length ? t.createElement(x, null, r.all.map(function (n, e) {
      return t.createElement(y, {
        key: n.id,
        index: e,
        level: n.level,
        onClick: function onClick() {
          r.dismiss(n);
        }
      }, "info" === n.level && t.createElement(i.InfoIcon, null), "success" === n.level && t.createElement(i.AlertIcon, null), "warn" === n.level && t.createElement(i.WarningIcon, null), "error" === n.level && t.createElement(i.ErrorIcon, null), t.createElement("p", null, n.message), t.createElement(b, null));
    })) : null;
  }, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});